// Lectura segura de JSON desde localStorage.
// Devuelve fallback si la clave no existe, está vacía o contiene JSON inválido,
// en lugar de lanzar y crashear el render.
export function getStoredJSON(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === "" || raw === "undefined") return fallback;
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}
